class MFRImageParallax {
    constructor( index, element ) {
        this.index = index;
        this.$element = $( element );
        this.$element.height( "100%" );
        this.imageType = this.$element.data( "image-parallax" );
        this.offsetPercentage = 0.1;
        this.offset = this.$element.height() * this.offsetPercentage;
        this.init();
    }

    init() {
        if( $( "html" ).hasClass( "has-scroll-smooth" ) ) this.initLocomotiveParallax()
        else this.initGSAPParallax()
    }

    initLocomotiveParallax() {
        this.addLocomotiveStyling();
        this.addLocomotiveAttributes();
    }
    
    addLocomotiveStyling() {
        this.$element.css( {
            height: `calc( 100% + ${ this.offset }px )`,
            marginTop: `-${ this.offset }px`
        } );
    }

    addLocomotiveAttributes() {
        this.$element.attr( {
            "data-scroll": "",
            "data-scroll-speed": "-1.5"
        } );
        window.mfrScroll.update();
    }

    initGSAPParallax() {
        this.addGSAPStyling();
        this.initGSAPfunction();
    }

    addGSAPStyling() {
        this.$element.css( {
            height: `calc( 100% + ${ this.offset }px )`,
        } );
    }

    initGSAPfunction() {
        gsap.registerPlugin(ScrollTrigger);

        gsap.fromTo( 
            this.$element, {
                y: 0
            }, 
            {
                y: `-${ this.offset }px`,
                ease: "power1.out",
                scrollTrigger: {
                    trigger: this.$element.closest( "div" ),
                    scrub: 2,
                    start: "top bottom",
                    end: "bottom top",
                    // markers: true
                }
            }
        );
    }
}